import React, { useEffect, useState } from 'react';

function LoadingScreen() {
  const [isLoadingComplete, setIsLoadingComplete] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoadingComplete(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-white bg-opacity-50">
      <img src="/logo1.svg" alt="Logo" className="w-24 h-24 mb-1" />
      <img
        src="/logo.svg"
        alt="Logo"
        className="w-24 h-24 mb-8 -translate-y-8"
      />
    </div>
  );
}

export default LoadingScreen;
